import { useCallback, useState } from "react";
import { DEFAULT_INGEST_PORT } from "@/constants";
import type { CreateServiceRequest } from "@/types/api";
import { HttpSourceFields } from "./HttpSourceFields";
import { validateRouteFormat } from "./routeValidation";

export function useHttpSourceFields() {
  // Row values as typed — blanks and in-progress edits stay until submit,
  // where toPayload trims, validates and drops empty rows.
  const [routes, setRoutes] = useState<string[]>([""]);

  const toPayload = useCallback((): Partial<CreateServiceRequest> => {
    const cleaned: string[] = [];
    for (const raw of routes) {
      const route = raw.trim();
      if (!route) continue;
      const error = validateRouteFormat(route);
      if (error) throw new Error(`Route '${route}': ${error}`);
      if (cleaned.includes(route))
        throw new Error(`Duplicate route '${route}'`);
      cleaned.push(route);
    }
    return { port: DEFAULT_INGEST_PORT, routes: cleaned };
  }, [routes]);

  const fields = <HttpSourceFields routes={routes} setRoutes={setRoutes} />;

  return { fields, toPayload };
}
